// src/pages/workloads/CreateWorkloadPage.tsx
import React, { useEffect } from 'react';
import { useWorkloadStore } from '../../store/workloadStore';
import { WorkloadCreationWizard } from '../../components/workloads/creation';

const CreateWorkloadPage: React.FC = () => {
  const { resetCreation } = useWorkloadStore();

  // Reset creation state on mount
  useEffect(() => {
    resetCreation();
  }, [resetCreation]);

  return <WorkloadCreationWizard />;
};

export default CreateWorkloadPage;
